import { useState } from "react";
import { ArrowRight, Check, Download } from "lucide-react";
import { toast } from "sonner";
import { api, errorMessage } from "@/lib/api";

export const SubscribeForm = ({ source, testidPrefix, buttonLabel, successText, placeholder = "La tua email", onSubscribed }) => {
  const [email, setEmail] = useState("");
  const [state, setState] = useState("idle");
  const [flashUrl, setFlashUrl] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    if (!/^\S+@\S+\.\S+$/.test(email)) {
      toast.error("Inserisci un'email valida");
      return;
    }
    setState("loading");
    try {
      const { data } = await api.post("/subscribe", { email, source });
      setFlashUrl(`${process.env.REACT_APP_BACKEND_URL}${data.flash_url}`);
      setState("done");
      onSubscribed?.(data);
      toast.success(data.already ? "Eri già in lista, grande." : successText, { description: "Il tuo Flash Pack è pronto: scaricalo qui sotto o dall'email." });
    } catch (err) {
      setState("idle");
      toast.error(errorMessage(err, "Email non valida, riprova."));
    }
  };

  if (state === "done") {
    return (
      <div data-testid={`${testidPrefix}-success`} className="flex flex-wrap items-center justify-between gap-4 border-b border-acid py-4">
        <span className="flex items-center gap-3 text-acid">
          <Check className="h-5 w-5 shrink-0" />
          <span className="font-mono text-xs uppercase tracking-[0.2em]">{successText}</span>
        </span>
        <a
          href={flashUrl}
          download
          data-testid={`${testidPrefix}-flash-download`}
          className="inline-flex h-10 items-center gap-2 rounded-full bg-acid px-5 font-mono text-[11px] uppercase tracking-[0.18em] text-ink transition-transform duration-300 hover:-translate-y-0.5 active:scale-95"
        >
          <Download className="h-3.5 w-3.5" /> Scarica il Flash Pack
        </a>
      </div>
    );
  }

  return (
    <form onSubmit={submit} noValidate className="group flex items-center gap-3 border-b border-bone/25 transition-colors focus-within:border-acid">
      <input
        type="email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder={placeholder}
        data-testid={`${testidPrefix}-email-input`}
        className="h-14 flex-1 bg-transparent text-base text-bone outline-none placeholder:text-smoke"
      />
      <button
        type="submit"
        disabled={state === "loading"}
        data-testid={`${testidPrefix}-submit-button`}
        className="inline-flex h-10 items-center gap-2 rounded-full bg-acid px-5 font-mono text-[11px] uppercase tracking-[0.18em] text-ink transition-transform duration-300 hover:-translate-y-0.5 active:scale-95 disabled:opacity-60"
      >
        {state === "loading" ? "…" : buttonLabel} <ArrowRight className="h-3.5 w-3.5" />
      </button>
    </form>
  );
};
